import { selectPrefersHelplyAccountId } from 'selectors/app/selectAccountPreferences'

export const selectHelplyAccountId = state => {
  const helplyAccountId = selectPrefersHelplyAccountId(state)
  if (helplyAccountId) return helplyAccountId
  return null
}
